import React from 'react'
import { useLocation } from 'react-router-dom';

function DeliverySecurity({ payment }) {
    const location = useLocation();
    const isTrackingPage = location.pathname.includes('/usr/track/');
    return (
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark">
            <div className="p-6 md:p-8">
                <div className="border-l-4 border-info pl-4 py-4">
                    <h3 className="font-bold text-info text-lg">Delivery Security & Confirmation</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                        {isTrackingPage ? (
                            <>
                                To verify your identity and confirm receipt, please provide the <strong>confirmation code</strong> sent to your checkout email when your order is delivered.
                                Keep it close!
                            </>
                        ) : (
                            <>
                                To complete this delivery, ask the recipient for the <strong>confirmation code</strong> sent to their checkout email.
                                Do not release the order without verifying the correct code.
                            </>
                        )}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default DeliverySecurity